import { useLayoutEffect, useState } from "react";

const YOIFORM_URL = "https://xezqjp2z0y7.typeform.com/to/FyfuEZhV";
const THEME_STORAGE_KEY = "numria-theme";

function readStoredDark(): boolean {
	if (typeof window === "undefined") return false;
	return localStorage.getItem(THEME_STORAGE_KEY) === "dark";
}

function SvgResearch() {
	return (
		<svg
			width="11"
			height="11"
			viewBox="0 0 16 16"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.8"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<title>Research</title>
			<circle cx="6.5" cy="6.5" r="4" />
			<line x1="9.8" y1="9.8" x2="13.5" y2="13.5" />
		</svg>
	);
}

function SvgRisk() {
	return (
		<svg
			width="11"
			height="11"
			viewBox="0 0 16 16"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<title>Risk</title>
			<path d="M8 2L2.5 5v4.5C2.5 12.5 5 14.5 8 15c3-0.5 5.5-2.5 5.5-5.5V5L8 2z" />
			<line x1="8" y1="7" x2="8" y2="9.5" />
			<circle cx="8" cy="11.5" r="0.6" fill="currentColor" stroke="none" />
		</svg>
	);
}

function SvgTax() {
	return (
		<svg
			width="11"
			height="11"
			viewBox="0 0 16 16"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.8"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<title>Tax</title>
			<rect x="3" y="1.5" width="10" height="13" rx="1" />
			<path d="M6 7.5h4M6 10h4M6 5h2" />
		</svg>
	);
}

function SvgPlanning() {
	return (
		<svg
			width="11"
			height="11"
			viewBox="0 0 16 16"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.8"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<title>Planning</title>
			<rect x="2" y="3.5" width="12" height="10.5" rx="1" />
			<line x1="2" y1="7" x2="14" y2="7" />
			<line x1="5.5" y1="1.5" x2="5.5" y2="5" />
			<line x1="10.5" y1="1.5" x2="10.5" y2="5" />
		</svg>
	);
}

function SvgExec() {
	return (
		<svg
			width="11"
			height="11"
			viewBox="0 0 16 16"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<title>Execution</title>
			<path d="M9 2L4.5 8.5H8L7 14l4.5-6.5H8.5L9 2z" />
		</svg>
	);
}

function SvgAgentRowResearch() {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 16 16"
			fill="none"
			stroke="#4A9EE0"
			strokeWidth="1.7"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<circle cx="6.5" cy="6.5" r="4" />
			<line x1="9.8" y1="9.8" x2="13.5" y2="13.5" />
		</svg>
	);
}

function SvgAgentRowRisk() {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 16 16"
			fill="none"
			stroke="#E05252"
			strokeWidth="1.7"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<path d="M8 2L2.5 5v4.5C2.5 12.5 5 14.5 8 15c3-.5 5.5-2.5 5.5-5.5V5L8 2z" />
			<line x1="8" y1="7" x2="8" y2="9.5" />
			<circle cx="8" cy="11.5" r="0.6" fill="#E05252" stroke="none" />
		</svg>
	);
}

function SvgAgentRowTax() {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 16 16"
			fill="none"
			stroke="#C9A84C"
			strokeWidth="1.7"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<rect x="3" y="1.5" width="10" height="13" rx="1" />
			<path d="M6 7.5h4M6 10h4M6 5h2" />
		</svg>
	);
}

function SvgAgentRowPlanning() {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 16 16"
			fill="none"
			stroke="#A78BFA"
			strokeWidth="1.7"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<rect x="2" y="3.5" width="12" height="10.5" rx="1" />
			<line x1="2" y1="7" x2="14" y2="7" />
			<line x1="5.5" y1="1.5" x2="5.5" y2="5" />
			<line x1="10.5" y1="1.5" x2="10.5" y2="5" />
		</svg>
	);
}

function SvgAgentRowExec() {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 16 16"
			fill="none"
			stroke="#3EC97A"
			strokeWidth="1.7"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<path d="M9 2L4.5 8.5H8L7 14l4.5-6.5H8.5L9 2z" />
		</svg>
	);
}

function SvgAgentCouncil() {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 24 24"
			fill="none"
			stroke="#C9A84C"
			strokeWidth="1.7"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<circle cx="12" cy="12" r="2.5" />
			<circle cx="12" cy="12" r="7" />
			<line x1="12" y1="2" x2="12" y2="5" />
			<line x1="12" y1="19" x2="12" y2="22" />
			<line x1="2" y1="12" x2="5" y2="12" />
			<line x1="19" y1="12" x2="22" y2="12" />
			<line x1="4.93" y1="4.93" x2="7.05" y2="7.05" />
			<line x1="16.95" y1="16.95" x2="19.07" y2="19.07" />
			<line x1="19.07" y1="4.93" x2="16.95" y2="7.05" />
			<line x1="7.05" y1="16.95" x2="4.93" y2="19.07" />
			<circle cx="12" cy="5" r="1" fill="#C9A84C" stroke="none" />
			<circle cx="12" cy="19" r="1" fill="#C9A84C" stroke="none" />
			<circle cx="5" cy="12" r="1" fill="#C9A84C" stroke="none" />
			<circle cx="19" cy="12" r="1" fill="#C9A84C" stroke="none" />
			<circle cx="7.05" cy="7.05" r="1" fill="#C9A84C" stroke="none" />
			<circle cx="16.95" cy="16.95" r="1" fill="#C9A84C" stroke="none" />
			<circle cx="16.95" cy="7.05" r="1" fill="#C9A84C" stroke="none" />
			<circle cx="7.05" cy="16.95" r="1" fill="#C9A84C" stroke="none" />
		</svg>
	);
}

const MODE_ICON_RAYS = [0, 45, 90, 135, 180, 225, 270, 315] as const;

function modeIconRayRect(deg: number) {
	const rad = (deg * Math.PI) / 180;
	const cx = 12 + 5.35 * Math.cos(rad);
	const cy = 12 + 5.35 * Math.sin(rad);
	const size = 1.25;
	return { x: cx - size / 2, y: cy - size / 2, size };
}

function SvgSun() {
	return (
		<svg
			width="30"
			height="30"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1"
			aria-hidden="true"
		>
			<title>Sun</title>
			<circle cx="12" cy="12" r="10.25" />
			<circle cx="12" cy="12" r="2.35" />
			{MODE_ICON_RAYS.map((deg) => {
				const { x, y, size } = modeIconRayRect(deg - 90);
				return (
					<rect
						key={deg}
						x={x}
						y={y}
						width={size}
						height={size}
						fill="currentColor"
						stroke="none"
					/>
				);
			})}
		</svg>
	);
}

function SvgMoon() {
	return (
		<svg
			width="30"
			height="30"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<title>Moon</title>
			<circle cx="12" cy="12" r="10.25" />
			<g transform="rotate(45 12 12)" strokeWidth="1.5">
				<g transform="translate(12 12) scale(0.52) translate(-12 -12)">
					<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
				</g>
			</g>
		</svg>
	);
}

function TickerSet() {
	return (
		<>
			<span className="ticker-item">
				<span className="ticker-badge research">
					<SvgResearch />
					Research
				</span>
				Your portfolio jumped <span className="up">+8.3%</span> this week · NVDA
				leading
			</span>
			<span className="ticker-item">
				<span className="ticker-badge risk">
					<SvgRisk />
					Risk
				</span>
				Concentration risk detected · tech weighting at{" "}
				<span className="dn">41%</span>
			</span>
			<span className="ticker-item">
				<span className="ticker-badge tax">
					<SvgTax />
					Tax
				</span>
				$6,200 in harvestable losses identified across 3 positions
			</span>
			<span className="ticker-item">
				<span className="ticker-badge planning">
					<SvgPlanning />
					Planning
				</span>
				RSU vest in 9 days · exercise strategy ready for your review
			</span>
			<span className="ticker-item">
				<span className="ticker-badge exec">
					<SvgExec />
					Execution
				</span>
				Rebalance approved · 4 trades queued at optimal timing
			</span>
			<span className="ticker-item">
				<span className="ticker-badge research">
					<SvgResearch />
					Research
				</span>
				AI stocks tumble <span className="dn">−6.1%</span> · position thesis
				under review
			</span>
			<span className="ticker-item">
				<span className="ticker-badge tax">
					<SvgTax />
					Tax
				</span>
				Roth conversion window open · advisor flagged before year-end
			</span>
			<span className="ticker-item">
				<span className="ticker-badge risk">
					<SvgRisk />
					Risk
				</span>
				Portfolio beta normalized to <span className="up">0.84</span> after
				hedge adjustment
			</span>
			<span className="ticker-item">
				<span className="ticker-badge planning">
					<SvgPlanning />
					Planning
				</span>
				401(k) limit · $3,400 in contributions remaining this year
			</span>
			<span className="ticker-item">
				<span className="ticker-badge exec">
					<SvgExec />
					Execution
				</span>
				AAPL limit order filled at <span className="up">$208.14</span> · 2.1%
				below ask
			</span>
		</>
	);
}

export function HomePage() {
	const [isDark, setIsDark] = useState(readStoredDark);

	useLayoutEffect(() => {
		document.documentElement.classList.toggle("dark", isDark);
	}, [isDark]);

	function toggleColorMode() {
		setIsDark((d) => {
			const next = !d;
			localStorage.setItem(THEME_STORAGE_KEY, next ? "dark" : "light");
			return next;
		});
	}

	return (
		<>
			<nav>
				<div className="logo">NUMRIA</div>
				<ul>
					<li>
						<a href="#team">Your team</a>
					</li>
					<li>
						<a href="#how">How it works</a>
					</li>
					<li>
						<a href="#security">Security</a>
					</li>
					<li>
						<a href="#pricing">Pricing</a>
					</li>
				</ul>
				<div className="nav-right">
					<button
						type="button"
						className="mode-toggle"
						onClick={toggleColorMode}
						aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
						aria-pressed={isDark}
					>
						{isDark ? <SvgMoon /> : <SvgSun />}
					</button>
					<a
						href={YOIFORM_URL}
						className="nav-cta"
						target="_blank"
						rel="noopener noreferrer"
					>
						Request access
					</a>
				</div>
			</nav>

			<div className="ticker">
				<div className="ticker-inner">
					<TickerSet />
					<TickerSet />
				</div>
			</div>

			<section className="hero">
				<div className="hero-grid">
					<div>
						<h1>
							Your <em>finance team,</em> powered by AI agents, backed by human
							experts.
						</h1>
						<p className="hero-desc">
							AI agents proactively working for you in tight coordination with
							CFPs and CPAs — researching, planning, monitoring, and executing
							around the clock. The future of personal finance, available now,
							with modular pricing.
						</p>
						<div className="hero-actions">
							<a
								href={YOIFORM_URL}
								className="btn-primary"
								target="_blank"
								rel="noopener noreferrer"
							>
								Join the waitlist
							</a>
							<a href="#team" className="btn-ghost">
								Meet your team
							</a>
						</div>
					</div>
					<div>
						<div className="brief-card">
							<div className="brief-header">
								<span className="bh-left">Numria Daily Brief</span>
								<span className="bh-right">
									Today · 7:02 AM · 5 agents active
								</span>
							</div>
							<div className="brief-body">
								<div className="brief-item">
									<div className="bi-dot green" />
									<div className="bi-content">
										<div className="bi-agent">Tax Agent</div>
										<div className="bi-main">
											Flagged <strong>$4,820 tax-loss harvesting</strong>{" "}
											opportunity in NVDA position
										</div>
										<div className="bi-sub">
											✓ Sara (CFP®) reviewed and approved · 6:44 AM
										</div>
									</div>
								</div>
								<div className="brief-item">
									<div className="bi-dot gold" />
									<div className="bi-content">
										<div className="bi-agent">Planning Agent</div>
										<div className="bi-main">
											RSU vest in <strong>12 days</strong> — 3 exercise
											scenarios modeled for your tax bracket
										</div>
										<div className="bi-sub amber">→ Awaiting your review</div>
									</div>
								</div>
								<div className="brief-item">
									<div className="bi-dot gold" />
									<div className="bi-content">
										<div className="bi-agent">Risk Agent</div>
										<div className="bi-main">
											Portfolio beta drifted to <strong>0.91</strong> —
											rebalance proposal ready
										</div>
										<div className="bi-sub amber">→ Awaiting your approval</div>
									</div>
								</div>
								<div className="brief-item">
									<div className="bi-dot muted" />
									<div className="bi-content">
										<div className="bi-agent">Research Agent</div>
										<div className="bi-main">
											AAPL earnings beat consensus · thesis unchanged
										</div>
										<div className="bi-sub muted">No action required</div>
									</div>
								</div>
							</div>
							<div className="brief-footer">
								<span className="bf-left">
									<span>2 items</span> need your approval
								</span>
								<a
									href={YOIFORM_URL}
									className="bf-cta"
									target="_blank"
									rel="noopener noreferrer"
								>
									Review now →
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>

			<div className="stats">
				<div className="stats-inner">
					<div>
						<div className="stat-val">5</div>
						<div className="stat-label">AI agents on your team</div>
					</div>
					<div>
						<div className="stat-val">24/7</div>
						<div className="stat-label">Monitoring your money</div>
					</div>
					<div>
						<div className="stat-val">$0</div>
						<div className="stat-label">Minimum to get started</div>
					</div>
					<div>
						<div className="stat-val">SOC 2</div>
						<div className="stat-label">Compliant · built in-house</div>
					</div>
				</div>
			</div>

			<section className="problem">
				<div className="section-inner">
					<div className="section-label">Why Numria</div>
					<h2>
						AI precision. Human judgment. <em>Exponential results.</em>
					</h2>
					<div className="problem-grid">
						<div className="problem-card">
							<div className="problem-num">01</div>
							<h3>The old model is broken</h3>
							<p>
								Traditional advisors spend 80% of their time on admin and
								prospecting — then charge you 1% a year for the privilege.
								Numria replaces that model entirely: AI handles the grunt work,
								so every human interaction is genuinely high-value.
							</p>
						</div>
						<div className="problem-card">
							<div className="problem-num">02</div>
							<h3>Advisors with a force multiplier</h3>
							<p>
								Our advisors were hired to work alongside AI, not adapt to it.
								They bring judgment, empathy, and fiduciary accountability. The
								agents bring speed, scale, and 24/7 coverage. Neither is enough
								alone — together they&apos;re a different category entirely.
							</p>
						</div>
						<div className="problem-card">
							<div className="problem-num">03</div>
							<h3>Reimagined by AI &amp; Fintech Experts</h3>
							<p>
								Built by a team of repeat founders and technology innovators —
								no legacy tools, no industry dinosaurs. Every feature was
								designed to deliver institutional-grade financial service as
								intuitively and seamlessly as possible. No fluff, simply what
								matters.
							</p>
						</div>
					</div>
				</div>
			</section>

			<section id="team">
				<div className="section-inner">
					<div className="agents-header">
						<div>
							<div className="section-label">Your team</div>
							<h2>
								Five AI agents. One <em>coordinated</em> plan.
							</h2>
						</div>
						<p className="section-desc">
							Each agent is a specialist with its own tools and mandate. They
							share context, debate trade-offs, and surface clear, explainable
							recommendations — coordinated in ways no traditional firm can
							replicate. The only platform designed from day one for this.
						</p>
					</div>
					<div className="agent-grid">
						<div className="agent-card">
							<div className="agent-icon-row">
								<SvgAgentRowResearch />
								<span className="agent-icon agent-icon--research">
									AGENT_01
								</span>
							</div>
							<h3>Research Agent</h3>
							<p>
								Continuously ingests earnings transcripts, SEC filings, analyst
								reports, and news. Synthesises a living thesis for every
								position in your universe.
							</p>
							<div className="agent-tags">
								<span className="tag tag--research">Earnings</span>
								<span className="tag tag--research">Filings</span>
								<span className="tag tag--research">Thesis</span>
							</div>
						</div>
						<div className="agent-card">
							<div className="agent-icon-row">
								<SvgAgentRowRisk />
								<span className="agent-icon agent-icon--risk">AGENT_02</span>
							</div>
							<h3>Risk Agent</h3>
							<p>
								Monitors portfolio-level risk in real time. Enforces drawdown
								limits, hedges tail exposure, and raises alerts before losses
								compound into larger ones.
							</p>
							<div className="agent-tags">
								<span className="tag tag--risk">Drawdown</span>
								<span className="tag tag--risk">Hedging</span>
								<span className="tag tag--risk">Alerts</span>
							</div>
						</div>
						<div className="agent-card">
							<div className="agent-icon-row">
								<SvgAgentRowTax />
								<span className="agent-icon agent-icon--tax">AGENT_03</span>
							</div>
							<h3>Tax Agent</h3>
							<p>
								Runs year-round tax planning. Harvests losses, coordinates
								across accounts, flags estimated tax deadlines, and hands off to
								a CPA when you need one.
							</p>
							<div className="agent-tags">
								<span className="tag tag--tax">Harvesting</span>
								<span className="tag tag--tax">Planning</span>
								<span className="tag tag--tax">Prep</span>
							</div>
						</div>
						<div className="agent-card">
							<div className="agent-icon-row">
								<SvgAgentRowPlanning />
								<span className="agent-icon agent-icon--planning">
									AGENT_04
								</span>
							</div>
							<h3>Planning Agent</h3>
							<p>
								Tracks equity vests, retirement contributions, and life events.
								Models decisions before you make them — purchases, option
								exercises, and rollovers.
							</p>
							<div className="agent-tags">
								<span className="tag tag--planning">Equity comp</span>
								<span className="tag tag--planning">Retirement</span>
								<span className="tag tag--planning">Life events</span>
							</div>
						</div>
						<div className="agent-card">
							<div className="agent-icon-row">
								<SvgAgentRowExec />
								<span className="agent-icon agent-icon--exec">AGENT_05</span>
							</div>
							<h3>Execution Agent</h3>
							<p>
								Routes orders intelligently to minimise slippage and cost.
								Manages position sizing, timing, and limit orders — operating
								within the thresholds you define.
							</p>
							<div className="agent-tags">
								<span className="tag tag--exec">Smart routing</span>
								<span className="tag tag--exec">Sizing</span>
								<span className="tag tag--exec">Timing</span>
							</div>
						</div>
						<div className="agent-card">
							<div className="agent-icon-row">
								<SvgAgentCouncil />
								<span className="agent-icon">COUNCIL</span>
							</div>
							<h3>Numria Council</h3>
							<p>
								Where agents debate, challenge each other, and reach consensus.
								Surfaces a single auditable recommendation for you to review and
								approve.
							</p>
							<div className="agent-tags">
								<span className="tag">Consensus</span>
								<span className="tag">Explainable</span>
								<span className="tag">Audit trail</span>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="how" id="how">
				<div className="section-inner">
					<div className="section-label">How it works</div>
					<h2>
						From sign-up to <em>your first plan</em> in minutes.
					</h2>
					<div className="steps">
						<div className="step">
							<div className="step-num">01</div>
							<h3>Sign up free</h3>
							<p>
								Link your brokerage, bank, and credit card accounts securely.
								Upload your tax documents. Your agents start building your full
								financial picture within minutes.
							</p>
						</div>
						<div className="step">
							<div className="step-num">02</div>
							<h3>Meet your team</h3>
							<p>
								Your five agents go to work — analyzing holdings, flagging tax
								opportunities, modeling life events, and prepping
								recommendations tailored to you.
							</p>
						</div>
						<div className="step">
							<div className="step-num">03</div>
							<h3>Get clear recommendations</h3>
							<p>
								Daily briefings and trade proposals in plain English. Every
								recommendation shows reasoning, confidence, and a dissenting
								view if one exists.
							</p>
						</div>
						<div className="step">
							<div className="step-num">04</div>
							<h3>Add humans when you want</h3>
							<p>
								Fully customizable plans. Upgrade anytime to the next tier for
								dedicated advisors. Pay à la carte, one-time or recurring, no
								commitment.
							</p>
						</div>
					</div>
				</div>
			</section>

			<section id="security">
				<div className="section-inner">
					<div className="section-label">Security &amp; trust</div>
					<h2>
						Your money. Your data. <em>Your call.</em>
					</h2>
					<div className="security-grid">
						<ul className="security-list">
							<li>
								<div className="icon">RIA</div>
								<div>
									<h4>We are legally bound to act in your best interest</h4>
									<p>
										Numria is a registered investment adviser. That&apos;s not a
										tagline — it&apos;s a fiduciary duty. Every recommendation
										we make is legally required to put you first.
									</p>
								</div>
							</li>
							<li>
								<div className="icon">ENC</div>
								<div>
									<h4>Bank-grade encryption</h4>
									<p>
										AES-256 encryption in transit and at rest. Read-only
										brokerage connections wherever possible. We never touch your
										login credentials.
									</p>
								</div>
							</li>
							<li>
								<div className="icon">ISO</div>
								<div>
									<h4>Isolated instances</h4>
									<p>
										Your agents run in a dedicated compute sandbox. No shared
										infrastructure, no cross-account bleed, no data co-mingled
										with anyone else&apos;s.
									</p>
								</div>
							</li>
							<li>
								<div className="icon">MFA</div>
								<div>
									<h4>You or your advisor approve every trade</h4>
									<p>
										Agents never execute material trades without explicit
										approval — yours or your advisor&apos;s, within limits you
										define. Multi-factor authentication on every action.
									</p>
								</div>
							</li>
							<li>
								<div className="icon">LOG</div>
								<div>
									<h4>Full audit trail</h4>
									<p>
										Every agent decision, every human recommendation, every
										trade is logged and explainable. You can see exactly why
										anything happened.
									</p>
								</div>
							</li>
						</ul>
						<div className="sandbox-diagram">
							<div className="sandbox-title">How it&apos;s built</div>
							<div className="sandbox-layer sl-outer">
								<div className="sandbox-label">
									Numria Cloud · SOC 2 Type II
								</div>
								<div className="sandbox-layer sl-mid">
									<div className="sandbox-label">Your dedicated sandbox</div>
									<div className="sandbox-layer sl-inner">
										<div className="sandbox-label">Your agent team</div>
										<div className="agent-pills">
											<span className="agent-pill">research</span>
											<span className="agent-pill">tax</span>
											<span className="agent-pill">risk</span>
											<span className="agent-pill">planning</span>
											<span className="agent-pill">execution</span>
										</div>
									</div>
									<div className="sandbox-mid-note">
										↕ encrypted brokerage links&nbsp;|&nbsp;read-only market
										data
									</div>
								</div>
								<div className="sandbox-outer-note">
									→ your approval gate&nbsp;|&nbsp;fiduciary human
									review&nbsp;|&nbsp;audit log
								</div>
							</div>
							<div className="sandbox-footnote">
								Agents cannot reach the internet except via whitelisted data
								providers.
							</div>
						</div>
					</div>
				</div>
			</section>

			<section
				id="pricing"
				style={{
					background: "var(--surface)",
					borderTop: "1px solid var(--border)",
				}}
			>
				<div className="section-inner">
					<div className="section-label">Pricing</div>
					<h2>
						Start free. Get human support <em>as you need it.</em>
					</h2>
					<div className="pricing-grid">
						<div className="price-card">
							<div className="price-name">Free</div>
							<div className="price-amount">
								<span>$</span>0
							</div>
							<div className="price-period">forever</div>
							<div className="price-tagline">Customize your own plan</div>
							<ul className="price-features">
								<li>Unified dashboard &amp; insights</li>
								<li>AI tax preparation</li>
								<li>Core investment agents</li>
								<li>On-demand expert access</li>
								<li>Add only what you want</li>
								<li className="dim">Full agent council</li>
							</ul>
							<a
								href={YOIFORM_URL}
								className="price-cta"
								target="_blank"
								rel="noopener noreferrer"
							>
								Join the waitlist
							</a>
						</div>

						<div className="price-card featured">
							<div className="price-badge">Most popular</div>
							<div className="price-name">Coached</div>
							<div className="price-amount">
								<span>$</span>100<small>/mo</small>
							</div>
							<div className="price-period">billed monthly</div>
							<div className="price-tagline">Someone in your corner</div>
							<ul className="price-features">
								<li>Everything in Free</li>
								<li>Advisors on-demand</li>
								<li>Full agent council</li>
								<li>CPA-reviewed W-2 return</li>
								<li>Insurance analysis</li>
								<li>24/7 response time</li>
								<li className="dim">Dedicated advisors</li>
							</ul>
							<a
								href={YOIFORM_URL}
								className="price-cta"
								target="_blank"
								rel="noopener noreferrer"
							>
								Try Coached
							</a>
						</div>

						<div className="price-card">
							<div className="price-name">Managed</div>
							<div className="price-amount">
								<span>$</span>350<small>/mo</small>
							</div>
							<div className="price-period">billed monthly</div>
							<div className="price-tagline">Half the traditional fee</div>
							<ul className="price-features">
								<li>Everything in Coached</li>
								<li>Dedicated CFP &amp; CPA</li>
								<li>Quarterly portfolio reviews</li>
								<li>Custom indexing &amp; ETFs</li>
								<li>Tax-loss harvesting</li>
								<li>Roth conversion analysis</li>
								<li>Equity comp &amp; tax coordination</li>
								<li className="dim">AI hedge fund agents</li>
							</ul>
							<a
								href={YOIFORM_URL}
								className="price-cta"
								target="_blank"
								rel="noopener noreferrer"
							>
								Get Managed
							</a>
						</div>

						<div className="price-card">
							<div className="price-name">Pro</div>
							<div className="price-amount">
								<span>$</span>500<small>/mo</small>
							</div>
							<div className="price-period">accredited only</div>
							<div className="price-tagline">Private markets access</div>
							<ul className="price-features">
								<li>Everything in Managed</li>
								<li>Dedicated expert team</li>
								<li>Private markets &amp; deal flow</li>
								<li>AI hedge fund agents</li>
								<li>Estate coordination</li>
								<li>Advanced tax structuring</li>
								<li>Priority access to events</li>
								<li className="dim">Institutional platform</li>
							</ul>
							<a
								href={YOIFORM_URL}
								className="price-cta"
								target="_blank"
								rel="noopener noreferrer"
							>
								Apply for Pro
							</a>
						</div>
					</div>

					<div className="ala-carte">
						<span className="lead">Add anytime →</span>
						<span className="chip">Home purchase plan</span>
						<span className="chip">Stock option exercise strategy</span>
						<span className="chip">Divorce financial analysis</span>
						<span className="chip">Business sale planning</span>
						<span className="chip">Inheritance &amp; estate guidance</span>
						<span className="chip">Social Security optimization</span>
						<span className="chip">Tax audit support</span>
					</div>
				</div>
			</section>

			<section className="final-cta">
				<div
					className="section-label"
					style={{ justifyContent: "center", display: "flex" }}
				>
					Early access
				</div>
				<h2>
					Finance is <em>finally on your side.</em>
				</h2>
				<p>
					The industry is rapidly evolving. Join the waitlist and be among the
					first to experience what AI-native, human-maximized financial service
					feels like.
				</p>
				<div className="cta-actions">
					<a
						href={YOIFORM_URL}
						className="btn-primary"
						target="_blank"
						rel="noopener noreferrer"
					>
						Request early access
					</a>
					<a
						href={YOIFORM_URL}
						className="btn-ghost"
						target="_blank"
						rel="noopener noreferrer"
					>
						Contact us
					</a>
				</div>
			</section>

			<footer>
				<div className="footer-logo">NUMRIA</div>
				<div className="footer-links">
					<a href="#private-label">Private-label</a>
					<a href="#security">Security</a>
					<a href="#privacy">Privacy</a>
					<a href="#terms">Terms</a>
				</div>
				<div className="footer-note">© 2026 Numria, Inc.</div>
			</footer>
			<div id="private-label" className="sr-only" tabIndex={-1}>
				Private-label
			</div>
			<div id="privacy" className="sr-only" tabIndex={-1}>
				Privacy
			</div>
			<div id="terms" className="sr-only" tabIndex={-1}>
				Terms
			</div>
			<p className="disclaimer">
				Numria&apos;s Free and Coached tiers are software tools and do not
				constitute investment advice. The Managed and Pro tiers are offered
				through Numria Advisors, a registered investment adviser. Past
				performance does not guarantee future results. Investing involves risk,
				including possible loss of principal. For informational purposes only.
			</p>
		</>
	);
}
